import { ServerService } from '@affine/core/modules/cloud';
import { useErpProvisioning } from '@affine/core/modules/erp';
import { FeatureFlagService } from '@affine/core/modules/feature-flag';
import { useLiveData, useService } from '@toeverything/infra';

export const useEnableAI = () => {
  const featureFlagService = useService(FeatureFlagService);
  const aiFeature = useLiveData(featureFlagService.flags.enable_ai.$);

  const serverService = useService(ServerService);
  const serverConfig = useLiveData(serverService.server.features$);
  const aiConfig = serverConfig.copilot;

  // Owner decision 2026-09-06: the AI-chat policy is a SERVER verdict (a modular
  // PIPE_AI_ACCESS_POLICY knob, e.g. "site admins only") — `/me/provisioning`'s `canUseAiAgents`
  // publishes it so every AI entry point in the app (this hook gates all of them) hides from ONE
  // server-derived flag, never a re-derived role check (4B.6). Keep entry points hidden until
  // provisioning explicitly grants access, including during a failed or pending fetch.
  const provisioning = useErpProvisioning();
  const canUseAiAgents = provisioning?.canUseAiAgents ?? false;

  return aiFeature && aiConfig && canUseAiAgents;
};
